import SliderData from './SliderData';
import ColorizeSlider from './ColorizeSlider';

export interface SliderProps {
    min: number;
    max: number;
    currentValue: number;
    unit: string;
    dangerZoneBelowValue?: number | false;
    dangerZoneAboveValue?: number | false;
    roundValues: boolean;
    keepInitialValueInSliderRange: boolean;
    inputsAboveSlider?: boolean;
    sliderWidth?: number;
    // resolution?: 'day';
}

interface sliderTelematicsCallbacks {
    onSliderChange: (currentValue: number) => void;
}

export class sliderTelematicsSingle {
    private root: HTMLDivElement;
    private props: SliderProps;
    private callbacks: sliderTelematicsCallbacks;

    constructor(root: HTMLDivElement, props: SliderProps, callbacks: sliderTelematicsCallbacks) {
        this.root = root;
        this.props = props;
        this.callbacks = callbacks;
        this.init();
    }

    init() {
        let color_selected = '#a4d86a';
        let min = this.props.min;
        let max = this.props.max;
        let currentValue = this.props.currentValue;
        if (this.props.keepInitialValueInSliderRange) {
            // console.debug('sliderInside, keepInitialValueInSliderRange', this.props.keepInitialValueInSliderRange);
            currentValue = Math.min(this.props.currentValue, max);
            currentValue = Math.max(currentValue, min);
        }
        let sliderData = new SliderData()
            .setSliderWidth(this.props?.sliderWidth ?? 400)
            .setSliderHeight(15)
            .setMinimum(min)
            .setUnit(this.props.unit)
            .setVisibleMinMax(min, max)
            .allowOutsideExtremumValues(true)
            .setAllowMinMaxSymbols(false)
            .setRoundValues(this.props.roundValues);

        // console.debug('sliderInside, sliderData init 1', sliderData);
        // console.debug('sliderInside, currentValue', currentValue);
        sliderData.addBlock(currentValue, color_selected);

        // console.debug('sliderInside, sliderData init 2', sliderData.getBlock(0));

        let colorizeSlider = new ColorizeSlider(
            sliderData,
            {
                enableAddRemovePeriods: false,
                enableColorPicker: false,
                darkMode: false,
                sliderMode: 'range',
                smallInputs: false,
                inputsAboveSlider: this.props.inputsAboveSlider ?? false,
                // valueSuffix: this.props.unit,
                dangerZoneBelowValue: this.props.dangerZoneBelowValue ?? false,
                dangerZoneAboveValue: this.props.dangerZoneAboveValue ?? false,
                enableSmartRounding: true,
            },
            {
                onSliderChange: (sliderData: SliderData) => {
                    console.log('updateDraggableElement');
                    this.callbacks.onSliderChange(sliderData.getBlocks()[0].max);
                },
                onSliderDragMove: (sliderData: SliderData) => {
                    colorizeSlider.reloadSVGBackground();
                },
            }
        );

        this.root.appendChild(colorizeSlider.getSlider());
    }
}
